import { hideTelegramKeyboard } from '../platform/telegram';

/** True when a pointer target is a real DOM editor that should keep the software keyboard open. */
export function isEditableTarget(target: EventTarget | null): boolean {
  const node = target as (HTMLElement & { tagName?: string }) | null;
  const tag = node?.tagName?.toUpperCase();
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || node?.isContentEditable === true;
}

/**
 * End the active DOM edit session and ask Telegram to hide its native keyboard when that API exists.
 * Blurring first is important for @pixi/ui: its blur handler commits the value and removes the
 * temporary transparent input.
 */
export function dismissKeyboard(doc: Document | undefined = typeof document === 'undefined' ? undefined : document): void {
  const active = doc?.activeElement as (HTMLElement & { blur?: () => void }) | null | undefined;
  if (active && isEditableTarget(active)) {
    active.blur?.();
    hideTelegramKeyboard();
  }
}

let installed = false;

/** Dismiss the current editor on any tap outside a real DOM input. Installed once for the app lifetime. */
export function installKeyboardDismissal(doc: Document | undefined = typeof document === 'undefined' ? undefined : document): void {
  if (!doc || installed) return;
  installed = true;
  doc.addEventListener('pointerdown', (event) => {
    if (!isEditableTarget(event.target)) dismissKeyboard(doc);
  }, true);
}
